import { init as initAccountNavigation } from './account-navigation';
import { init as initMyPurchaseModule } from './account-purchases';


export const init = () => {
  initMyPurchaseModule();
  const completion = cube.$id('js-profile-completion');
  const notificationsLists = cube.$$('.dash-card__notifications');

  if (completion)
    loadProfileCompletion(completion.dataset.value);

  if (notificationsLists)
    loadNotifications(notificationsLists);
};


/**
 * Show the completion percentage of the profile
 *
 * @param {Integer} completion the percentage of completion
 */
const loadProfileCompletion = completion => {
  const circle = cube.$id('js-profile-completion-circle');
  const text = cube.$id('js-profile-completion-value');

  const { strokeDasharray, transitionDuration } = getComputedStyle(circle);
  const dashoffset = strokeDasharray.replace('px','') * ( 100 - completion ) / 100;

  const interval = setInterval(() => {
    const value = text.textContent;

    if (value === completion)
      clearInterval(interval);
    else
      text.textContent = Number(value) + 1;
  }, transitionDuration / completion);

  circle.style.strokeDashoffset = dashoffset;
};


/**
 * Initialize notifications carousels
 *
 * @param {NodeList} notificationsLists mandatory
 */
const loadNotifications = notificationsLists => {
  $(notificationsLists).slick({
    infinite: true,
    arrows: true,
    dots: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  notificationsLists.forEach(notificationsList => {
    const cart = notificationsList.closest('.dash-card__container');
    const close = cart && cart.$('.close-notification');
    const link = cart && cart.$('.notification-link');

    if (close) {
      close.addEventListener('click', (e) => {
        e.preventDefault();
        updateNotification('REMOVE', cart, notificationsList);
      });
    }

    if (link) {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        updateNotification('READ', cart, notificationsList);
      });
    }
  });
};

/**
 * Update the current notification
 *
 * @param {string} action mandatory
 * @param {HTMLElement} cart mandatory
 * @param {NodeList} notificationsList mandatory
 */
const updateNotification = (action, cart, notificationsList) => {
  const currentNotification = notificationsList.$('.slick-current');
  const currentNotificationId = currentNotification.id;

  switch (action) {
    case 'REMOVE': {
      cube.ajax
        .post('account/deleteNotification', { notificationId: currentNotificationId })
        .onSuccess(() => {
          removeNotification(cart, notificationsList);

          cube.cartridge('header-my-account')
            .reload();

          cube.cartridge('dashboard-account-nav')
            .after(() => {
              initAccountNavigation();
            })
            .reload();
        })
        .call();

      break;
    }

    case 'READ': {
      if (currentNotification.dataset.isRead === 'false') {
        cube.ajax
          .post('account/readNotification', { notificationId: currentNotificationId })
          .onSuccess(() => {
            readNotification(cart);
          })
          .call();
      }

      break;
    }

    default:
  }
};


/**
 * Remove the current notification
 *
 * @param {HTMLElement} cart mandatory
 * @param {NodeList} notificationsList mandatory
 */
const removeNotification = (cart, notificationsList) => {
  const notifications = $(notificationsList);
  const current = notifications.slick('slickCurrentSlide');

  notifications.slick('slickRemove', current);

  if (!notifications.slick('getSlick').slideCount) {
    cart.parentNode.removeChild(cart);
  }
};


/**
 * Redirect to cart's url after it updated
 *
 * @param {HTMLElement} cart mandatory
 */
const readNotification = cart => {
  window.location = cart.$('.clickable-area').href;
};



// WEBPACK FOOTER //
// ./src/customer/account/account-dashboard.js